export { convertCase };

function convertCase(string) {
    return string
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/stringUtils.js